// extracted by mini-css-extract-plugin
module.exports = {"widgetsGrid":"NewWidgetForm_widgetsGrid__1wm78","bottomActions":"NewWidgetForm_bottomActions__2zYI9"};